<template>
  <div class="dialog-container" v-loading="isLoading">
    <el-alert class="mb-3" :title="errorMessage" type="error" show-icon v-if="errorMessage"></el-alert>
    <el-row :gutter="18">
      <el-col :span="24">
        <el-form ref="editDeposit" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="Check #" prop="checkNumber">
            <el-input v-model="form.checkNumber" placeholder="Check Number" :disabled="!isAdmin"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog">Close</el-button>
        <el-button type="primary" @click="updateCheckNumber" v-if="isAdmin">Update Deposit</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import get from 'lodash/get';
import api from '@/api';
import { Required } from '@/util/formValidators';
import Deposit from '@/model/Deposit';

export default {
  props: {
    deposit: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      isLoading: false,
      errorMessage: null,
      form: new Deposit(),
      rules: {
        checkNumber: [Required],
      },
    };
  },
  methods: {
    updateCheckNumber() {
      this.errorMessage = null;
      this.$refs.editDeposit.validate((valid) => {
        if (valid) {
          this.isLoading = true;
          api.deposit.update(this.form).then((response) => {
            this.$notify.success({
              title: 'Success',
              message: 'Deposit saved.',
              position: 'bottom-right',
            });
            this.$emit('depositUpdated', response.data);
            this.closeDialog();
          }).catch((e) => {
            this.errorMessage = get(e, 'response.data', 'An error occurred.');
          }).finally(() => {
            this.isLoading = false;
          });
          return true;
        }
        return false;
      });
    },
    closeDialog() {
      this.clearForm();
      this.$emit('close');
    },
    setForm(deposit) {
      if (deposit) {
        this.form = new Deposit(this.deposit);
      } else {
        this.clearForm();
      }
    },
    clearForm() {
      this.form = new Deposit(this.deposit);
      this.$refs.editDeposit.resetFields();
    },
  },
  computed: {
    ...mapGetters('User', [
      'isAdmin',
    ]),
  },
  watch: {
    deposit(val) {
      this.setForm(val);
    },
  },
  mounted() {
    if (this.deposit) {
      this.setForm(this.deposit);
    }
  },
};

</script>
